<div class="dx-fieldset" style="max-width: 600px;">
  <div class="dx-field">
    <div class="dx-field-label jobListTD">{{ 'E/D/E Mitgliedsnummer' | translate }}</div>
    <div class="dx-field-value">
      <dx-text-box  [(value)]="memberId.memberId" (onChange)="update()" [showClearButton]="true"></dx-text-box>
    </div>
  </div>
</div>

